import React, { useState } from 'react';
import TextInput from '../TextInput/TextInput';
import './SortCodeInput.scss';

type sortCodeProps = {
  label: string;
  value1: string;
  value2: string;
  value3: string;
  error: string;
  onChange: (e: React.FormEvent<HTMLInputElement>, key: string) => void;
};

export const SortCodeInput = ({
  label: label,
  value1: value1,
  value2: value2,
  value3: value3,
  error: error,
  onChange: onChange
}: sortCodeProps): JSX.Element => {
  const [focusedElement, setFocusedElement] = useState<null | string>(null);

  const getSortCodeLabelPanel = () => {
    if (label && label.length > 0) {
      return <div className='d-block'>{label}</div>;
    }
  };

  const onChangeValue = (
    e: React.FormEvent<HTMLInputElement>,
    value: string
  ) => {
    onChange(e, value);
    //Don't want to check for new focus if the section is not complete
    if (e.currentTarget.value.length < 2) return;

    switch (e.currentTarget.name) {
      case 'sort-code-1':
        setFocusedElement('sort-code-2');
        break;
      case 'sort-code-2':
        setFocusedElement('sort-code-3');
        break;
      default:
        setFocusedElement(null);
        break;
    }
  };

  const onLeave = () => {
    setFocusedElement(null);
  };

  const onFocus = (e: React.FormEvent<HTMLInputElement>) => {
    e.currentTarget.select();
  };

  const getSortCodeInputPanel = () => {
    let inputClasses = '';
    if (error && error.length > 0) {
      inputClasses = 'has-error';
    }

    return (
      <div className={inputClasses}>
        <div className='d-inline-block me-1 sortcode'>
          <TextInput
            className='input-text'
            placeholder='00'
            name='sort-code-1'
            onChange={(e: React.FormEvent<HTMLInputElement>) =>
              onChangeValue(e, 'sortCode1')
            }
            value={value1}
            maxLength={2}
            focus={focusedElement === 'sort-code-1'}
            onLeave={onLeave}
            onFocus={onFocus}
          />
        </div>
        <div className='d-inline-block me-1 sortcode'>
          <TextInput
            className='input-text'
            placeholder='00'
            name='sort-code-2'
            onChange={(e: React.FormEvent<HTMLInputElement>) =>
              onChangeValue(e, 'sortCode2')
            }
            value={value2}
            maxLength={2}
            focus={focusedElement === 'sort-code-2'}
            onLeave={onLeave}
            onFocus={onFocus}
          />
        </div>
        <div className='d-inline-block sortcode'>
          <TextInput
            className='input-text'
            placeholder='00'
            name='sort-code-3'
            onChange={(e: React.FormEvent<HTMLInputElement>) =>
              onChangeValue(e, 'sortCode3')
            }
            value={value3}
            maxLength={2}
            focus={focusedElement === 'sort-code-3'}
            onLeave={onLeave}
            onFocus={onFocus}
          />
        </div>
      </div>
    );
  };

  const getSortCodeErrorPanel = () => {
    if (error && error.length > 0) {
      return (
        <div className='has-error'>
          <div className='input error-margin'>{error}</div>
        </div>
      );
    }
  };

  const labelPanel = getSortCodeLabelPanel();
  const inputPanel = getSortCodeInputPanel();
  const errorPanel = getSortCodeErrorPanel();

  return (
    <div>
      {labelPanel}
      {inputPanel}
      {errorPanel}
    </div>
  );
};
